import artificial from "../imgs/artificial.png";
import intelligence from "../imgs/intelligence.png";
import throne from "../imgs/Garfield_the_Cat.svg.png";
function HomePage() {
  return (
    <div className="home-page">
      <div className="throne">
        <img className="throne-img" src={throne}></img>
      </div>
      <div className="home-title">
        <div className="artificial">
          <img className="artificial-img" src={artificial}></img>
        </div>
        <div className="intelligence">
          <img className="intelligence-img" src={intelligence}></img>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
